import * as React from "react";
const SvgMinusOrange = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 2, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 2, style: {
  fill: "rgb(240, 109, 0)",
  strokeWidth: 0,
  stroke: "rgb(240, 109, 0)"
} }));
export default SvgMinusOrange;
